export const SET_LOADING_ADDED_FILE = 'SET_LOADING_ADDED_FILE'
export const ADDED_FILE_SUCCESS = 'ADDED_FILE_SUCCESS'
export const ADDED_FILE_FAILED = 'ADDED_FILE_FAILED'
export const SET_CLEARED_FILE = 'SET_CLEARED_FILE'